import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextFieldFullWidth from './TextFieldFullWidth';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { useFormFields } from '../libs/hooksLib';
import { isEmpty } from '../libs/isEmpty';

import Typography from '@material-ui/core/Typography'

export default function DatasourceModal({
  ...props
}) {

  const initalValues= () => {
    if (isEmpty(props.values)) {
      let obj = {
         active: false,
         alias: "",
         config: "",
         store_type: "WFS" 
      }
      return obj
    } else {
      //console.log(props.values)
      return props.values
    }
  }

  const [isLoading, setIsLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [fields, setValues, handleFieldChange] = useFormFields(initalValues);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [errorMessage, setErrorMessage] = React.useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setValues(initalValues)
    setOpen(false);
  };

  async function handleSubmit(event) {
    event.preventDefault();
    let body = fields
    //console.log(body)
    props.acceptAction({body})
    handleClose()
  }

  // Handle validation
  function validateForm() {
    let errors = []

    // Check for JSON in conf
    try {
        JSON.parse(fields.config);
    } catch (e) {
        errors.push("JSON: ikke valid")
    }

    if (fields.alias.length === 0) {
      errors.push("Alias: må ikke være tom.")
    }


    if (errors.length > 0) {
      return false
    } else {
      return true
    }
    
  }

  return (
    <div>
      <Button
        disabled={props.disabled}
        variant={props.btnVariant}
        color={props.btnColor}
        onClick={handleClickOpen}>
        {props.btnText}
      </Button>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="datasource-modal"
        fullWidth={true}
        maxWidth={"sm"}

      >
        <form noValidate autoComplete="off" onSubmit={handleSubmit} key={isLoading}>
        <DialogTitle id="datasource-modal">{props.titleText}</DialogTitle>
        <DialogContent>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
            <Grid item>
              <TextFieldFullWidth 
                id="alias"
                label="Alias"
                placeholder=""
                helperText="Navngivning"
                value={fields.alias}
                onChange={handleFieldChange}
                isLoading={isLoading}                  
              />
            </Grid>
            <Grid item>
              <TextFieldFullWidth 
                id="store_type"
                label="Type"
                placeholder=""
                helperText="Datastore stype"
                value={fields.store_type}
                onChange={handleFieldChange}
                isLoading={isLoading}                  
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                value={fields.active}
                control={<Checkbox id="active" size="medium" checked={fields.active} value={fields.active} onChange={handleFieldChange} color="primary" />}
                label="Aktiv"
                labelPlacement="end"
              />
            </Grid>
            <Grid item>
              {errorMessage.map(error => (
              <Typography variant="overline" display="block" color={"secondary"}>            
                {error}
              </Typography>
              ))}               
            </Grid>
            <Grid item style={{width: 450}}>
              <TextFieldFullWidth
                id="config"
                label="JSON"
                placeholder="{}"
                helperText="Konfiguration"
                value={fields.config}
                onChange={handleFieldChange}
                isLoading={isLoading}
                multiline
                minRows={8}
              />
            </Grid> 
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            {props.cancelText}
          </Button>
          <Button 
          //onClick={action} 
          color="primary" variant="contained" autoFocus type="submit" disabled={!validateForm()}>
            {props.acceptText}
          </Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}